import config from '@/config/config';

import Index from '@/pages/car-group/index.vue';
import List from '@/pages/car-group/list/list.vue';
import View from '@/pages/car-group/view/view.vue';
import New from '@/pages/car-group/new/new.vue';
import Edit from '@/pages/car-group/edit/edit.vue';

const modulePermission = config.modules.carGroup;

export default {
  path: '/car-group',
  name: 'car-group',
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: 'enabled_read',
  },
  children: [
    {
      path: 'list',
      name: 'car-group-list',
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
    },
    {
      path: ':id',
      name: 'car-group-view',
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
      props: true,
    },
    {
      path: 'new',
      name: 'car-group-new',
      component: New,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_create',
      },
    },
    {
      path: ':id/e',
      name: 'car-group-edit',
      component: Edit,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_edit',
      },
      props: true,
    },
  ],
};
